/*
 *
 * Artifactory is a binaries repository manager.
 * Copyright (C) 2018 JFrog Ltd.
 *
 * Artifactory is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 * Artifactory is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with Artifactory.  If not, see <http://www.gnu.org/licenses/>.
 *
 */
const {BASE_URL, API_VERSION, ARTIFACTORY_BASE_URL} = window.jf;

export default {
    "API_URL": `${BASE_URL}${API_VERSION}${ARTIFACTORY_BASE_URL}`,
    "AUTH_LOGIN": "/auth/login?_spring_security_remember_me=",
    "AUTH_CURRENT": "/auth/current",
    "AUTH_LOGOUT": "/auth/logout",
    "AUTH_IS_SAML": "/auth/issaml",
    "AUTH_REDIRECT": "/auth/redirect?redirectTo=",
    "AUTH_FORGOT_PASSWORD": "/auth/forgotpassword",
    "AUTH_VALIDATE_KEY": '/auth/validatetoken?key=',
    "AUTH_RESET_PASSWORD": "/auth/resetpassword?key=",
    "AUTH_LOGIN_DATA": '/auth/loginRelatedData',
    "AUTH_CAN_ANNOTATE": '/auth/canAnnotate?repoKey=',
    "CRYPTO": "/crypto",
    "SECURITY_CONFIG": "/securityconfig",
    "USERS": "/users",
    "GROUPS": "/groups",
    "GROUP_PERMISSION": "/groupPermission",
    "MAIL": "/mail",
    "REGISTER_PRO": "/registerlicense",
    "MANAGE_HA_LICENSES": "/manageLicenses",
    "PROXIES": "/proxies",
    "REVERSE_PROXIES": "/reverseProxies",
    "HTTPSSO": "/httpsso",
    "SSHSERVER": "/sshserver",
    "LICENSES": "/licenses",
    "HIGH_AVAILABILITY": "/highAvailability",
    "XRAY": "/xrayRepo",
    "XRAY_CONFIG": "/xrayConfig",
    "SAML_CONFIG": "/saml/config",
    "SAML_DOWNLOAD_ENCRYPTED_ASSERTION_CERT": "/saml/config/key/public",
    "SAML_LOGOUT": "/saml/logoutRequest",
    "OAUTH_LOGIN": "/oauth2/loginRequestPlatform",
    "BINTRAY_SETTING": "/bintraysetting",
    "PROPERTY_SETS": "/propertysets",
    "BROWSE_FILESYSTEM": "/browsefilesystem",
    "BACKUP": "/backup",
    "SYSTEM_INFO": "/systeminfo",
    "CONFIG_DESCRIPTOR": "/configdescriptor",
    "SECURITY_DESCRIPTOR": "/securitydescriptor",
    "INDEXER": "/indexer",
    "STORAGE_SUMMARY": "/storagesummary",
    "TREE_BROWSER": "/treebrowser",
    "REPO_DATA": "/repodata",
    "CRON_TIME": "/crontime",
    "DATE_FORMAT": "/validations/dateformat",
    "NAME_VALIDATOR": "/validations/name",
    "UNIQUE_ID_VALIDATOR": "/validations/uniqueid",
    "XML_NAME_VALIDATOR": "/validations/xmlname",
    "ARTIFACT_PERMISSIONS": "/artifactpermissions",
    "ARTIFACT_GENERAL": "/artifactgeneral",
    "ARTIFACT_GENERAL_BINTRAY": "/artifactgeneral/bintray",
    "ARTIFACT_GENERAL_BINTRAY_DIST": "/artifactgeneral/bintray/dist",
    "ARTIFACT_VIEW_SOURCE": "/archiveViewSource",
    "ARTIFACT_BUILDS": "/artifactbuilds",
    "ARTIFACT_XRAY": "/artifactxray",
    "XRAY_UI": "xray",
    "ARTIFACT_ACTIONS": "/artifactactions",
    "ARTIFACT_PROPERTIES": "/artifactproperties",
    "PREDEFINE_VALUES": "/predefinevalues",
    "REPO_PROPERTY_SET": "/repopropertyset",
    "ARTIFACT_WATCHES": "/artifactwatches",
    "ARTIFACT_SEARCH": "/artifactsearch",
    "DEPENDENCY_DECLARATION": "/dependencydeclaration",
    "ARTIFACT": "/artifact",
    "FOOTER":"/auth/screen/footer",
    "VIEWS":"/views",
    "CROWD":"/crowd",
    "EXPORT": "/artifactexport",
    "IMPORT": "/artifactimport",
    "MAINTENANCE": "/maintenance",
    "LDAP": "/ldap",
    "OAUTH": "/oauth",
    "CHECKSUMS": "/checksums",
    "FILTERED_RESOURCE": "/filteredResource",
    "LDAP_GROUPS": "/ldapgroups",
    "PUSH_TO_BINTRAY": "/pushToBintray",
    "BINTRAY_DISTRIBUTION": "/distribution",
    "GENERAL_CONFIG": "/generalConfig",
    "ONBOARDING": "/onboarding",
    "SIGNINGKEYS": "/signingkeys",
    "TRUSTEDKEYS": "/security/trustedKeys",
    "SSLCERTIFICATES":"/admin/security/certificates",
    "ACCESSTOKENS": "/admin/security/accesstokens",
    "KEYSTORE":"/keystore",
    "USER_PROFILE": "/userProfile",
    "SSH_CLIENT": "/sshClient",
    "USER_API_KEY": "/userApiKey",
    "BUILDS": "/builds",
    "BUNDLES": "/bundles",
    "EFFECTIVE_PERMISSIONS_BUNDLES": "/bundles/effectivePermission",
    "BUILDS_INFO": "/buildsinfo",  /// JUST FOR MOCK, WILL BE REMOVED
    "PERMISSION_TARGETS": "/permissiontargets",
    "GENERAL_TAB_LICENSES":"/generalTabLicenses",
    "HOME_PAGE": "/home",
    "SYSTEM_LOGS": "/systemlogs",
    "SET_ME_UP": "/setMeUp",
    "SET_ME_UP_MAVEN": "/setMeUp/mavenSettings",
    "SET_ME_UP_GRADLE": "/setMeUp/gradleSettings",
    "SET_ME_UP_IVY": "/setMeUp/ivySettings",
    "SET_ME_UP_MAVEN_DISTRIBUTION": "/setMeUp/mavenDistributionManagement",
    "SET_ME_UP_MAVEN_SNIPPET": "/setMeUp/mavenSnippet",
    "SET_ME_UP_GRADLE_SNIPPET": "/setMeUp/gradleSnippet",
    "SET_ME_UP_IVY_SNIPPET": "/setMeUp/ivySnippet",
    "SET_ME_UP_REVERSE_PROXY_DATA": "/setMeUp/reverseProxyData",
    "DOWNLOAD_MAVEN_SNIPPET": "/setMeUp/downloadBuildMaven",
    "DOWNLOAD_GRADLE_SNIPPET": "/setMeUp/downloadBuildGradle",
    "DOWNLOAD_IVY_SNIPPET": "/setMeUp/downloadBuildIvy",
    "REPOSITORIES":"/admin/repositories",
    "REPOSITORIES_LAYOUTS":"/admin/repolayouts",
    "STASH_RESULTS":"/stashResults",
    "SUPPORT_PAGE":"/userSupport",
    "SERVER_TIME":"/system/serverTime",
    "LICENSE_DETAILS":"/system/license",
    "BINARY_PROVIDERS_INFO":"/binary/providers/info",
    "DOCKER_STATUS":"/admin/repositories/getdockerstatus",
    "GLOBAL_REPLICATIONS_BLOCK":"/global/replications/config",
    "SUMOLOGIC": "/sumologic",
    "PIPELINES_EFFECTIVE_PERMISSIONS": "pipe/api/effectivePermissions"

}



// WEBPACK FOOTER //
// ./constants/api.constants.js